import {
  VENDOR_PROFILE_ACTION,
  VENDOR_TRANSACTIONS_ACTION,
  VENDOR_OVERVIEW_ACTION,
  VENDOR_SETTLEMENTS_ACTION,
  VENDOR_QR_CODE_ACTION,
  UPDATE_DISCOUNT_PERCENTAGE_ACTION,
  DOWNLOAD_QR_CODE_ACTION,
  UPDATE_VENDOR_PROFILE_ACTION,
} from "./types";

export const getVendorProfileAction = () => ({
  type: VENDOR_PROFILE_ACTION,
});

export const getVendorTransactionsAction = (data) => ({
  type: VENDOR_TRANSACTIONS_ACTION,
  payload: data,
});

export const getVendorOverviewAction = (data) => ({
  type: VENDOR_OVERVIEW_ACTION,
  payload: data,
});

export const getVendorSettlementsAction = (data) => ({
  type: VENDOR_SETTLEMENTS_ACTION,
  payload: data,
});

export const getVendorQRCodeAction = () => ({
  type: VENDOR_QR_CODE_ACTION,
});

export const updateDiscountPercentageAction = (data) => ({
  type: UPDATE_DISCOUNT_PERCENTAGE_ACTION,
  payload: data,
});

export const downloadQRCodeAction = () => ({
  type: DOWNLOAD_QR_CODE_ACTION,
});

export const updateVendorProfileAction = (data) => ({
  type: UPDATE_VENDOR_PROFILE_ACTION,
  payload: data,
});
